import styled from "styled-components";

export const CollabToggleWrapper = styled("div")`
  margin: 0 1rem 0 2rem;
  min-width: 120px;
`;
